import { useState, useEffect } from 'react'
import { useParams, useNavigate } from 'react-router'
import api from '../lib/api'

const TABS = ['General', 'Base de datos', 'Credenciales MH', 'Emisor', 'Correlativos', 'DTEs', 'Usuarios', 'Límites', 'Módulos']

// ── Sub-componentes de cada tab ─────────────────────────────────────────────

function TabGeneral({ tenant, onToggleActive }) {
  return (
    <div className="content">
      <div style={{ display: 'flex', alignItems: 'center', gap: '16px', padding: '4px 0' }}>
        <div className="t-logo" style={{ width: '52px', height: '52px', fontSize: '18px', background: 'linear-gradient(135deg,#3b4fd8,#6d28d9)' }}>
          {tenant.company_name.slice(0,2).toUpperCase()}
        </div>
        <div>
          <div style={{ fontSize: '20px', fontWeight: 800 }}>{tenant.company_name}</div>
          <div style={{ display: 'flex', gap: '8px', marginTop: '6px' }}>
            <span className={`badge ${tenant.active ? 'badge-ok' : 'badge-neutral'}`}>{tenant.active ? 'Activo' : 'Inactivo'}</span>
            <span className={`badge ${tenant.ambiente === '01' ? 'badge-prod' : 'badge-test'}`}>{tenant.ambiente === '01' ? 'Producción' : 'Pruebas'}</span>
          </div>
        </div>
        <div style={{ marginLeft: 'auto', textAlign: 'right' }}>
          <div style={{ fontSize: '11px', color: 'var(--muted)' }}>URL de acceso</div>
          <div style={{ fontSize: '15px', fontWeight: 700, color: 'var(--accent)' }}>{tenant.subdomain}.efactura.sv</div>
        </div>
      </div>

      <div className="three-col">
        <div className="detail-box"><div className="detail-label">NIT</div><div className="detail-value mono">{tenant.nit}</div></div>
        <div className="detail-box"><div className="detail-label">Subdominio</div><div className="detail-value mono">{tenant.subdomain}</div></div>
        <div className="detail-box"><div className="detail-label">Ambiente</div><div className="detail-value">{tenant.ambiente === '01' ? 'Producción' : 'Pruebas'}</div></div>
        <div className="detail-box"><div className="detail-label">Registrado</div><div className="detail-value">{new Date(tenant.created_at).toLocaleDateString('es-SV')}</div></div>
        <div className="detail-box"><div className="detail-label">DTEs este mes</div><div className="detail-value" style={{ fontWeight: 800 }}>{(tenant.dtes_mes ?? 0).toLocaleString()}</div></div>
        <div className="detail-box"><div className="detail-label">Estado</div><div className="detail-value">{tenant.active ? '✅ Activo' : '🔴 Inactivo'}</div></div>
      </div>

      <div className="two-col">
        <div className="panel">
          <div className="panel-head">Acciones rápidas</div>
          <div className="panel-body" style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
            <button className="btn btn-secondary">🔑 Renovar token MH</button>
            <button className="btn btn-secondary">📊 Ver DTEs de este tenant</button>
            <button className={`btn ${tenant.active ? 'btn-danger' : 'btn-success'}`} onClick={onToggleActive}>
              {tenant.active ? '⛔ Desactivar tenant' : '✅ Activar tenant'}
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

function TabBD({ tenant }) {
  const [result, setResult] = useState(null)
  const [testing, setTesting] = useState(false)

  const testConnection = async () => {
    setTesting(true)
    try {
      const { data } = await api.post('/wizard/test-db', {
        db_host:     tenant.db_host,
        db_port:     tenant.db_port,
        db_database: tenant.db_database,
        db_username: tenant.db_username,
        db_password: '***', // no disponible por seguridad
      })
      setResult({ ok: data.success, msg: data.message })
    } catch (e) {
      setResult({ ok: false, msg: e.response?.data?.message ?? 'Error de conexión' })
    } finally {
      setTesting(false)
    }
  }

  return (
    <div className="content">
      <div className="panel">
        <div className="panel-head">Conexión a base de datos propia</div>
        <div className="panel-body">
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px', marginBottom: '16px' }}>
            <div className="form-group"><div className="form-label">Host</div><input className="form-input mono" value={tenant.db_host} readOnly /></div>
            <div className="form-group"><div className="form-label">Puerto</div><input className="form-input mono" value={tenant.db_port ?? 3306} readOnly /></div>
            <div className="form-group"><div className="form-label">Base de datos</div><input className="form-input mono" value={tenant.db_database} readOnly /></div>
            <div className="form-group"><div className="form-label">Usuario</div><input className="form-input mono" value={tenant.db_username} readOnly /></div>
          </div>
          {result && (
            <div className={`conn-result ${result.ok ? 'ok' : 'err'}`} style={{ marginBottom: '12px' }}>
              {result.ok ? '✓' : '✕'} {result.msg}
            </div>
          )}
          <button className="btn btn-success" onClick={testConnection} disabled={testing}>
            {testing ? 'Probando…' : '⚡ Probar conexión'}
          </button>
        </div>
      </div>
    </div>
  )
}

function TabMH({ tenant, tokenStatus }) {
  return (
    <div className="content">
      <div className="panel">
        <div className="panel-head">Credenciales API — Ministerio de Hacienda</div>
        <div className="panel-body" style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
          <div className="form-group"><div className="form-label">Usuario API MH</div><input className="form-input mono" value={tenant.api_user ?? ''} readOnly /></div>
          <div className="form-group"><div className="form-label">Contraseña API MH</div><input className="form-input" type="password" value="••••••••••••" readOnly /></div>
          <div className="form-group"><div className="form-label">Contraseña certificado</div><input className="form-input" type="password" value="••••••••••••" readOnly /></div>

          {tokenStatus?.status === 'vencido' && (
            <div className="error-banner">⚠ Token vencido — los DTEs están detenidos</div>
          )}
          {tokenStatus?.status === 'por_vencer' && (
            <div className="warn-banner">⏱ Token vence en {tokenStatus.label} — se recomienda renovar</div>
          )}

          <div style={{ display: 'flex', gap: '8px' }}>
            <button className="btn btn-primary">🔑 Renovar token</button>
          </div>
        </div>
      </div>
    </div>
  )
}

function TabEmisores({ tenantId }) {
  const [emisor,  setEmisor]  = useState(null)
  const [loading, setLoading] = useState(true)
  const [error,   setError]   = useState(null)

  useEffect(() => {
    api.get(`/tenants/${tenantId}/emisor`)
      .then(({ data }) => setEmisor(data))
      .catch(() => setError('No se pudo cargar el emisor o la BD no está disponible.'))
      .finally(() => setLoading(false))
  }, [tenantId])

  if (loading) return <div className="content"><div style={{ color: 'var(--muted)' }}>Cargando…</div></div>
  if (error)   return <div className="content"><div className="error-banner">⚠ {error}</div></div>
  if (!emisor) return <div className="content"><div className="empty">Sin emisor configurado</div></div>

  return (
    <div className="content">
      <div className="panel">
        <div className="panel-head">Datos del emisor</div>
        <div className="panel-body">
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '12px' }}>
            <div className="detail-box"><div className="detail-label">Nombre comercial</div><div className="detail-value">{emisor.nombre ?? emisor.nombreComercial ?? '—'}</div></div>
            <div className="detail-box"><div className="detail-label">NIT</div><div className="detail-value mono">{emisor.nit ?? '—'}</div></div>
            <div className="detail-box"><div className="detail-label">NRC</div><div className="detail-value mono">{emisor.nrc ?? '—'}</div></div>
            <div className="detail-box"><div className="detail-label">Teléfono</div><div className="detail-value">{emisor.telefono ?? '—'}</div></div>
            <div className="detail-box"><div className="detail-label">Correo</div><div className="detail-value">{emisor.correo ?? '—'}</div></div>
            <div className="detail-box"><div className="detail-label">Actividad</div><div className="detail-value">{emisor.codActividad ?? '—'}</div></div>
          </div>
        </div>
      </div>
    </div>
  )
}

function TabCorrelativos({ tenantId }) {
  const [rows,    setRows]    = useState([])
  const [loading, setLoading] = useState(true)
  const [error,   setError]   = useState(null)

  const dteNames = { '01': 'FCF', '03': 'CCF', '05': 'NC', '11': 'FEX', '14': 'FES' }

  useEffect(() => {
    api.get(`/tenants/${tenantId}/correlativos`)
      .then(({ data }) => setRows(data))
      .catch(() => setError('No se pudo cargar los correlativos.'))
      .finally(() => setLoading(false))
  }, [tenantId])

  if (loading) return <div className="content"><div style={{ color: 'var(--muted)' }}>Cargando…</div></div>
  if (error)   return <div className="content"><div className="error-banner">⚠ {error}</div></div>

  return (
    <div className="content">
      <div className="table-wrap">
        <table>
          <thead><tr><th>Tipo DTE</th><th>Código</th><th>Establecimiento</th><th>Correlativo actual</th><th>Ambiente</th></tr></thead>
          <tbody>
            {rows.length === 0 && <tr><td colSpan={5} className="empty">Sin correlativos</td></tr>}
            {rows.map(r => (
              <tr key={r.id}>
                <td><span className={`dte dte-${(dteNames[r.tipo_dte] ?? 'fcf').toLowerCase()}`}>{dteNames[r.tipo_dte] ?? r.tipo_dte}</span></td>
                <td><span className="mono">{r.tipo_dte}</span></td>
                <td><span className="mono">{r.establecimiento ?? '—'}</span></td>
                <td style={{ fontWeight: 700 }}>{r.correlativo?.toLocaleString() ?? '—'}</td>
                <td>{r.ambiente === 'PRODUCCION' || r.ambiente === '01' ? <span className="badge badge-prod">Producción</span> : <span className="badge badge-test">Pruebas</span>}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  )
}

const TIPO_LABEL = { '01': 'FCF', '03': 'CCF', '05': 'NC', '11': 'FEX', '14': 'FES' }
const TIPO_COLOR = { '01': '#4f6ef7', '03': '#06b6d4', '05': '#ef4444', '11': '#22c55e', '14': '#f59e0b' }
const TIPO_CLS   = { '01': 'dte-fcf', '03': 'dte-ccf', '05': 'dte-nc', '11': 'dte-fex' }

function TabDtes({ tenantId }) {
  const [resumen,  setResumen]  = useState(null)
  const [loading,  setLoading]  = useState(true)
  const [error,    setError]    = useState(null)
  const [desde,    setDesde]    = useState('')
  const [hasta,    setHasta]    = useState('')

  function cargar(d = desde, h = hasta) {
    setLoading(true)
    setError(null)
    const params = { tenant_id: tenantId }
    if (d) params.desde = d
    if (h) params.hasta = h
    api.get('/dtes', { params })
      .then(({ data }) => setResumen(data))
      .catch(err => setError(err.response?.data?.message ?? 'Error al cargar datos.'))
      .finally(() => setLoading(false))
  }

  useEffect(() => { cargar() }, [tenantId]) // eslint-disable-line

  const total     = resumen?.total     ?? 0
  const porTipo   = resumen?.por_tipo   ?? {}
  const porEstado = resumen?.por_estado ?? {}
  const porMes    = resumen?.por_mes    ?? []

  return (
    <div className="content">
      {/* Filtro de fechas */}
      <div style={{ display: 'flex', gap: '10px', alignItems: 'flex-end', marginBottom: '20px' }}>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
          <label style={{ fontSize: '11px', color: 'var(--muted)', fontWeight: 600 }}>DESDE</label>
          <input type="date" className="form-input" style={{ height: '30px', fontSize: '12px', padding: '4px 8px', width: '140px' }}
            value={desde} onChange={e => setDesde(e.target.value)} />
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
          <label style={{ fontSize: '11px', color: 'var(--muted)', fontWeight: 600 }}>HASTA</label>
          <input type="date" className="form-input" style={{ height: '30px', fontSize: '12px', padding: '4px 8px', width: '140px' }}
            value={hasta} onChange={e => setHasta(e.target.value)} />
        </div>
        <button className="btn btn-primary btn-sm" style={{ height: '30px' }} onClick={() => cargar()}>
          Filtrar
        </button>
        {(desde || hasta) && (
          <button className="btn btn-ghost btn-sm" style={{ height: '30px' }}
            onClick={() => { setDesde(''); setHasta(''); cargar('', '') }}>
            Limpiar
          </button>
        )}
      </div>

      {error && <div className="error-banner">⚠ {error}</div>}

      {loading && <div style={{ color: 'var(--muted)', fontSize: '13px' }}>Cargando…</div>}

      {!loading && resumen && (
        <>
          <div style={{ fontSize: '28px', fontWeight: 800, marginBottom: '4px' }}>{total.toLocaleString()}</div>
          <div style={{ fontSize: '12px', color: 'var(--muted)', marginBottom: '20px' }}>documentos totales</div>

          <div className="two-col">
            <div className="panel">
              <div className="panel-head">Por tipo de documento</div>
              <div className="panel-body" style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                {Object.entries(TIPO_LABEL).map(([codigo, label]) => {
                  const cant = porTipo[codigo] ?? 0
                  const pct  = total > 0 ? Math.round((cant / total) * 100) : 0
                  return (
                    <div key={codigo} style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                      <span className={`dte ${TIPO_CLS[codigo] ?? 'dte-fcf'}`} style={{ minWidth: '36px', textAlign: 'center' }}>{label}</span>
                      <div className="bar-track" style={{ flex: 1 }}>
                        <div className="bar-fill" style={{ width: `${pct}%`, background: TIPO_COLOR[codigo] ?? '#888' }} />
                      </div>
                      <span style={{ fontWeight: 700, fontSize: '13px', minWidth: '48px', textAlign: 'right' }}>{cant.toLocaleString()}</span>
                      <span style={{ fontSize: '11px', color: 'var(--muted)', minWidth: '32px', textAlign: 'right' }}>{pct}%</span>
                    </div>
                  )
                })}
              </div>
            </div>

            <div style={{ display: 'flex', flexDirection: 'column', gap: '14px' }}>
              <div className="panel">
                <div className="panel-head">Por estado</div>
                <div className="panel-body" style={{ display: 'flex', gap: '12px', flexWrap: 'wrap' }}>
                  {[
                    { key: 'ENVIADO',   label: 'Enviados',   cls: 'badge-ok'      },
                    { key: 'PROCESADO', label: 'Procesados', cls: 'badge-ok'      },
                    { key: 'PENDIENTE', label: 'Pendientes', cls: 'badge-warn'    },
                    { key: 'RECHAZADO', label: 'Rechazados', cls: 'badge-err'     },
                    { key: 'ANULADO',   label: 'Anulados',   cls: 'badge-neutral' },
                  ].filter(({ key }) => porEstado[key] !== undefined).map(({ key, label, cls }) => (
                    <div key={key} style={{ flex: 1, minWidth: '80px', textAlign: 'center', padding: '12px 8px', background: 'var(--bg)', borderRadius: '8px', border: '1px solid var(--border)' }}>
                      <div style={{ fontSize: '20px', fontWeight: 800 }}>{(porEstado[key] ?? 0).toLocaleString()}</div>
                      <span className={`badge ${cls}`} style={{ marginTop: '6px', display: 'inline-block' }}>{label}</span>
                    </div>
                  ))}
                </div>
              </div>

              <div className="panel">
                <div className="panel-head">Últimos 6 meses</div>
                <div className="panel-body" style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                  {porMes.length === 0
                    ? <div style={{ color: 'var(--muted)', fontSize: '12px' }}>Sin datos en el período</div>
                    : porMes.map(m => {
                        const maxMes = Math.max(...porMes.map(x => x.total), 1)
                        return (
                          <div key={m.mes} style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                            <span style={{ fontSize: '11px', color: 'var(--muted)', minWidth: '54px' }}>{m.mes}</span>
                            <div className="bar-track" style={{ flex: 1 }}>
                              <div className="bar-fill" style={{ width: `${Math.round((m.total / maxMes) * 100)}%`, background: '#4f6ef7' }} />
                            </div>
                            <span style={{ fontWeight: 600, fontSize: '12px', minWidth: '40px', textAlign: 'right' }}>{m.total.toLocaleString()}</span>
                          </div>
                        )
                      })
                  }
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  )
}

function TabUsuarios({ tenantId }) {
  const [users,   setUsers]   = useState([])
  const [loading, setLoading] = useState(true)
  const [showForm, setShowForm] = useState(false)
  const [saving,  setSaving]  = useState(false)
  const [error,   setError]   = useState(null)
  const [form,    setForm]    = useState({ name: '', email: '', password: '' })
  const [showPass, setShowPass] = useState(false)

  function cargar() {
    setLoading(true)
    api.get(`/tenants/${tenantId}/usuarios`)
      .then(({ data }) => setUsers(data))
      .catch(() => {})
      .finally(() => setLoading(false))
  }

  useEffect(() => { cargar() }, [tenantId]) // eslint-disable-line

  function setField(k, v) { setForm(p => ({ ...p, [k]: v })) }

  async function handleSubmit(e) {
    e.preventDefault()
    setSaving(true)
    setError(null)
    try {
      await api.post(`/tenants/${tenantId}/usuarios`, form)
      setForm({ name: '', email: '', password: '' })
      setShowForm(false)
      cargar()
    } catch (err) {
      setError(err.response?.data?.message ?? err.response?.data?.error ?? 'Error al crear usuario.')
    } finally {
      setSaving(false)
    }
  }

  async function handleToggle(uid) {
    try {
      const { data } = await api.post(`/tenants/${tenantId}/usuarios/${uid}/toggle-active`)
      setUsers(prev => prev.map(u => u.id === uid ? { ...u, active: data.active } : u))
    } catch (err) {
      alert(err.response?.data?.message ?? 'Error al cambiar estado.')
    }
  }

  async function handleDelete(uid, name) {
    if (!window.confirm(`¿Eliminar al usuario "${name}"? Esta acción no se puede deshacer.`)) return
    try {
      await api.delete(`/tenants/${tenantId}/usuarios/${uid}`)
      setUsers(prev => prev.filter(u => u.id !== uid))
    } catch (err) {
      alert(err.response?.data?.message ?? 'Error al eliminar.')
    }
  }

  return (
    <div className="content">
      {/* Cabecera con botón nuevo */}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
        <span style={{ fontSize: '13px', color: 'var(--muted)' }}>{users.length} usuario{users.length !== 1 ? 's' : ''} registrado{users.length !== 1 ? 's' : ''}</span>
        <button className="btn btn-primary btn-sm" onClick={() => { setShowForm(p => !p); setError(null) }}>
          {showForm ? 'Cancelar' : '+ Nuevo usuario'}
        </button>
      </div>

      {/* Formulario */}
      {showForm && (
        <form onSubmit={handleSubmit} style={{ background: 'var(--surface)', border: '1px solid var(--border)', borderRadius: '10px', padding: '18px', marginBottom: '18px', display: 'flex', flexDirection: 'column', gap: '12px' }}>
          <div style={{ fontWeight: 700, fontSize: '13px', marginBottom: '2px' }}>Nuevo usuario</div>
          {error && <div className="error-banner" style={{ margin: 0 }}>⚠ {error}</div>}
          <div style={{ display: 'flex', gap: '12px', flexWrap: 'wrap' }}>
            <div style={{ flex: 1, minWidth: '180px', display: 'flex', flexDirection: 'column', gap: '4px' }}>
              <label style={{ fontSize: '11px', color: 'var(--muted)', fontWeight: 600 }}>NOMBRE</label>
              <input className="form-input" placeholder="Juan Pérez" required
                value={form.name} onChange={e => setField('name', e.target.value)} />
            </div>
            <div style={{ flex: 1, minWidth: '180px', display: 'flex', flexDirection: 'column', gap: '4px' }}>
              <label style={{ fontSize: '11px', color: 'var(--muted)', fontWeight: 600 }}>EMAIL</label>
              <input className="form-input" type="email" placeholder="usuario@empresa.com" required
                value={form.email} onChange={e => setField('email', e.target.value)} />
            </div>
            <div style={{ flex: 1, minWidth: '180px', display: 'flex', flexDirection: 'column', gap: '4px' }}>
              <label style={{ fontSize: '11px', color: 'var(--muted)', fontWeight: 600 }}>CONTRASEÑA</label>
              <div style={{ position: 'relative' }}>
                <input className="form-input" type={showPass ? 'text' : 'password'} placeholder="Mínimo 8 caracteres"
                  required minLength={8} style={{ width: '100%', paddingRight: '36px' }}
                  value={form.password} onChange={e => setField('password', e.target.value)} />
                <button type="button" onClick={() => setShowPass(p => !p)}
                  style={{ position: 'absolute', right: '8px', top: '50%', transform: 'translateY(-50%)', background: 'none', border: 'none', cursor: 'pointer', color: 'var(--muted)', fontSize: '13px' }}>
                  {showPass ? '🙈' : '👁'}
                </button>
              </div>
            </div>
          </div>
          <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
            <button className="btn btn-primary btn-sm" type="submit" disabled={saving}>
              {saving ? 'Guardando…' : 'Crear usuario'}
            </button>
          </div>
        </form>
      )}

      {/* Tabla */}
      <div className="table-wrap">
        <table>
          <thead>
            <tr><th>Usuario</th><th>Email</th><th>Estado</th><th>Registrado</th><th></th></tr>
          </thead>
          <tbody>
            {loading && <tr><td colSpan={5} style={{ textAlign: 'center', padding: '24px', color: 'var(--muted)' }}>Cargando…</td></tr>}
            {!loading && users.length === 0 && <tr><td colSpan={5} className="empty">Sin usuarios registrados</td></tr>}
            {!loading && users.map(u => (
              <tr key={u.id}>
                <td>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <div className="avatar" style={{ width: '26px', height: '26px', fontSize: '10px' }}>
                      {(u.name ?? '').slice(0, 2).toUpperCase()}
                    </div>
                    <span style={{ fontWeight: 600 }}>{u.name}</span>
                  </div>
                </td>
                <td style={{ color: 'var(--muted)', fontSize: '11px' }}>{u.email}</td>
                <td>
                  {u.active
                    ? <span className="badge badge-ok">Activo</span>
                    : <span className="badge badge-neutral">Inactivo</span>}
                </td>
                <td style={{ color: 'var(--muted)', fontSize: '11px' }}>
                  {new Date(u.created_at).toLocaleDateString('es-SV')}
                </td>
                <td>
                  <div style={{ display: 'flex', gap: '6px' }}>
                    <button
                      className="btn btn-ghost btn-sm"
                      style={{ color: u.active ? 'var(--yellow)' : 'var(--green)' }}
                      onClick={() => handleToggle(u.id)}
                    >
                      {u.active ? 'Desactivar' : 'Activar'}
                    </button>
                    <button className="btn btn-ghost btn-sm" style={{ color: 'var(--red)' }}
                      onClick={() => handleDelete(u.id, u.name)}>
                      Eliminar
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  )
}

function TabLimites({ tenantId }) {
  const [data,    setData]    = useState(null)
  const [loading, setLoading] = useState(true)
  const [saving,  setSaving]  = useState(false)
  const [error,   setError]   = useState(null)
  const [success, setSuccess] = useState(null)
  const [form,    setForm]    = useState({ whatsapp_mensual: '', email_mensual: '' })

  function cargar() {
    setLoading(true)
    api.get(`/tenants/${tenantId}/limits`)
      .then(({ data }) => {
        setData(data)
        setForm({ whatsapp_mensual: data.whatsapp.limite, email_mensual: data.email.limite })
      })
      .catch(() => setError('Error al cargar límites.'))
      .finally(() => setLoading(false))
  }

  useEffect(() => { cargar() }, [tenantId]) // eslint-disable-line

  async function handleSave(e) {
    e.preventDefault()
    setSaving(true)
    setError(null)
    setSuccess(null)
    try {
      const { data: updated } = await api.put(`/tenants/${tenantId}/limits`, {
        whatsapp_mensual: parseInt(form.whatsapp_mensual),
        email_mensual:    parseInt(form.email_mensual),
      })
      setData(updated)
      setSuccess('Límites actualizados correctamente.')
    } catch (err) {
      setError(err.response?.data?.message ?? 'Error al guardar.')
    } finally {
      setSaving(false)
    }
  }

  if (loading) return <div className="content" style={{ color: 'var(--muted)' }}>Cargando…</div>

  return (
    <div className="content">
      <div className="two-col" style={{ alignItems: 'start' }}>

        {/* Uso actual */}
        <div style={{ display: 'flex', flexDirection: 'column', gap: '14px' }}>
          {[
            { key: 'whatsapp', label: 'WhatsApp', icon: '💬', color: '#22c55e' },
            { key: 'email',    label: 'Email',    icon: '✉️',  color: '#4f6ef7' },
          ].map(({ key, label, icon, color }) => {
            const canal = data?.[key] ?? { uso: 0, limite: 0, disponible: 0 }
            const pct   = canal.limite > 0 ? Math.min(100, Math.round((canal.uso / canal.limite) * 100)) : 0
            const alerta = pct >= 90
            return (
              <div key={key} className="panel">
                <div className="panel-head">{icon} {label} — {data?.mes}</div>
                <div className="panel-body" style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '13px' }}>
                    <span style={{ color: 'var(--muted)' }}>Uso del mes</span>
                    <span style={{ fontWeight: 700, color: alerta ? 'var(--red)' : 'inherit' }}>
                      {canal.uso.toLocaleString()} / {canal.limite.toLocaleString()}
                    </span>
                  </div>
                  <div className="bar-track">
                    <div className="bar-fill" style={{ width: `${pct}%`, background: alerta ? 'var(--red)' : color, transition: 'width 0.3s' }} />
                  </div>
                  <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '11px', color: 'var(--muted)' }}>
                    <span>{pct}% consumido</span>
                    <span>{canal.disponible.toLocaleString()} restantes</span>
                  </div>
                  {alerta && (
                    <div style={{ fontSize: '11px', color: 'var(--red)', fontWeight: 600 }}>
                      ⚠ Límite casi alcanzado
                    </div>
                  )}
                </div>
              </div>
            )
          })}
        </div>

        {/* Formulario editar límites */}
        <div className="panel">
          <div className="panel-head">Editar límites mensuales</div>
          <form onSubmit={handleSave}>
            <div className="panel-body" style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
              {error   && <div className="error-banner" style={{ margin: 0 }}>⚠ {error}</div>}
              {success && <div style={{ background: '#d1fae5', border: '1px solid #6ee7b7', color: '#065f46', borderRadius: '8px', padding: '10px 14px', fontSize: '13px' }}>✓ {success}</div>}

              {[
                { key: 'whatsapp_mensual', label: 'WhatsApp / mes', icon: '💬' },
                { key: 'email_mensual',    label: 'Emails / mes',   icon: '✉️'  },
              ].map(({ key, label, icon }) => (
                <div key={key} style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                  <label style={{ fontSize: '11px', color: 'var(--muted)', fontWeight: 600 }}>
                    {icon} {label.toUpperCase()}
                  </label>
                  <input
                    type="number" min="0" required
                    className="form-input"
                    value={form[key]}
                    onChange={e => setForm(p => ({ ...p, [key]: e.target.value }))}
                  />
                </div>
              ))}

              <button className="btn btn-primary btn-sm" type="submit" disabled={saving} style={{ alignSelf: 'flex-end' }}>
                {saving ? 'Guardando…' : 'Guardar límites'}
              </button>
            </div>
          </form>
        </div>

      </div>
    </div>
  )
}

const FEATURES_INFO = {
  inventario: {
    label: 'Módulo de Inventario',
    desc:  'Control de stock, movimientos (ENTRADA/SALIDA/AJUSTE) y costo promedio ponderado.',
    icon:  '📦',
  },
}

function TabModulos({ tenantId }) {
  const [features, setFeatures] = useState([])
  const [loading,  setLoading]  = useState(true)
  const [toggling, setToggling] = useState({})

  function cargar() {
    setLoading(true)
    api.get(`/tenants/${tenantId}/features`)
      .then(({ data }) => setFeatures(data))
      .catch(() => {})
      .finally(() => setLoading(false))
  }

  useEffect(() => { cargar() }, [tenantId]) // eslint-disable-line

  async function handleToggle(feature) {
    setToggling(p => ({ ...p, [feature]: true }))
    try {
      const { data } = await api.post(`/tenants/${tenantId}/features/${feature}/toggle`)
      setFeatures(prev => prev.map(f => f.feature === feature ? { ...f, activo: data.activo } : f))
    } catch (err) {
      alert(err.response?.data?.message ?? 'Error al cambiar el módulo.')
    } finally {
      setToggling(p => ({ ...p, [feature]: false }))
    }
  }

  if (loading) return <div className="content"><div style={{ color: 'var(--muted)' }}>Cargando módulos…</div></div>

  return (
    <div className="content">
      <div style={{ display: 'flex', flexDirection: 'column', gap: '14px' }}>
        {features.length === 0 && (
          <div className="empty">No hay módulos disponibles.</div>
        )}
        {features.map(f => {
          const info = FEATURES_INFO[f.feature] ?? { label: f.feature, desc: '', icon: '🔧' }
          return (
            <div key={f.feature} className="panel">
              <div className="panel-body" style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
                <div style={{ fontSize: '28px' }}>{info.icon}</div>
                <div style={{ flex: 1 }}>
                  <div style={{ fontWeight: 700, fontSize: '14px' }}>{info.label}</div>
                  <div style={{ fontSize: '12px', color: 'var(--muted)', marginTop: '2px' }}>{info.desc}</div>
                </div>
                <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                  <span className={`badge ${f.activo ? 'badge-ok' : 'badge-neutral'}`}>
                    {f.activo ? 'Activo' : 'Inactivo'}
                  </span>
                  <button
                    className={`btn btn-sm ${f.activo ? 'btn-danger' : 'btn-success'}`}
                    onClick={() => handleToggle(f.feature)}
                    disabled={toggling[f.feature]}
                  >
                    {toggling[f.feature] ? '…' : f.activo ? 'Desactivar' : 'Activar'}
                  </button>
                </div>
              </div>
            </div>
          )
        })}
      </div>
    </div>
  )
}

// ── Pantalla principal ──────────────────────────────────────────────────────

export default function TenantDetail() {
  const { id } = useParams()
  const navigate = useNavigate()

  const [tenant,  setTenant]  = useState(null)
  const [loading, setLoading] = useState(true)
  const [error,   setError]   = useState(null)
  const [activeTab, setActiveTab] = useState(0)

  useEffect(() => {
    api.get(`/tenants/${id}`)
      .then(({ data }) => setTenant(data))
      .catch(() => setError('No se encontró el tenant.'))
      .finally(() => setLoading(false))
  }, [id])

  const handleToggleActive = async () => {
    try {
      const { data } = await api.post(`/tenants/${id}/toggle-active`)
      setTenant(prev => ({ ...prev, active: data.active }))
    } catch {}
  }

  if (loading) return <div className="content"><div style={{ color: 'var(--muted)' }}>Cargando…</div></div>
  if (error)   return <div className="content"><div className="error-banner">⚠ {error}</div></div>

  return (
    <>
      <div className="topbar">
        <div className="breadcrumb">
          <span className="crumb" onClick={() => navigate('/empresas')}>Empresas</span>
          <span className="sep">›</span>
          <strong>{tenant.company_name}</strong>
        </div>
        <div className="topbar-actions">
          <button className={`btn btn-sm ${tenant.active ? 'btn-danger' : 'btn-success'}`} onClick={handleToggleActive}>
            {tenant.active ? 'Desactivar' : 'Activar'}
          </button>
        </div>
      </div>

      <div className="screen-tabs">
        {TABS.map((tab, i) => (
          <div
            key={tab}
            className={`screen-tab${activeTab === i ? ' active' : ''}`}
            onClick={() => setActiveTab(i)}
          >
            {tab}
          </div>
        ))}
      </div>

      {activeTab === 0 && <TabGeneral tenant={tenant} onToggleActive={handleToggleActive} />}
      {activeTab === 1 && <TabBD tenant={tenant} />}
      {activeTab === 2 && <TabMH tenant={tenant} tokenStatus={tenant.token_status} />}
      {activeTab === 3 && <TabEmisores tenantId={id} />}
      {activeTab === 4 && <TabCorrelativos tenantId={id} />}
      {activeTab === 5 && <TabDtes tenantId={id} />}
      {activeTab === 6 && <TabUsuarios tenantId={id} />}
      {activeTab === 7 && <TabLimites tenantId={id} />}
      {activeTab === 8 && <TabModulos tenantId={id} />}
    </>
  )
}
